export function calculatePointAt(x: number, points: [number, number][]) {
  const len = points.length;
  let i = len;
  while (i-- && points[i][0] > x);
  if (i < 0) i = 0;
  if (i > len - 1) i = len - 1;

  const before = points[i];
  const after = points[Math.min(len - 1, i + 1)];
  if (!before && !after) return 0;
  if (!after) return before[1];
  if (!before) return after[1];
  const dx = after[0] - before[0],
    dy = after[1] - before[1];

  let y = before[1];
  if (before !== after) y += (x - before[0]) / (dx / dy);

  return y || 0;
}

export function getMinMax(
  points: [number, number][],
  axis: number = 0,
  start: number = 0,
  end: number = points.length
): [number, number] {
  const res = [Infinity, -Infinity];
  for (let i = start; i < end; i++) {
    const p = points[i];
    if (p[axis] < res[0]) res[0] = p[axis];
    if (p[axis] > res[1]) res[1] = p[axis];
  }
  return res;
}
